import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.7_@parcel+watcher@2.5.1_@types+node@22.17.0_@vue+compiler-sfc@3.5.17_db0@0.3._6cf49b862fc58a113b598ba5521ca066/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/vercel/path0/node_modules/.pnpm/@una-ui+content@48.2.0_@parcel+watcher@2.5.1_@types+node@22.17.0_@unhead+vue@2.0.12_vue_09715b43e1d136ccd69c8d74f80c91f0/node_modules/@una-ui/content/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}